


<div class="row">
    <div class="col-sm-9"></div>
    <div class="col-sm-3" style="text-align: right;">
        <button [useExistingCss]="true"  printSectionId="print-certificate" ngxPrint style="border: unset !important; background-color:#ffffff;" >
            <a > <img style="cursor: pointer;height: 17px; width: 18px;" src="assets/images/topprint.png"></a>
          </button> &nbsp; &nbsp;
          <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <i class="fa fa-times" style="font-size:13px;float:right; cursor: pointer;"></i>
          </button>
    </div>

</div>

<div class="container-fluid" style="border: 2px solid #000">
    <div class="row">
        <div class="container-fluid" style="border: 5px solid #000;margin:2px;">
            <div class="row">
        <div class="col-sm-4">
            <img style="height: 100px;" src="assets/images/mrdimage.jpg">
        </div>
        <div class="col-sm-4">
            
        </div>
        <div class="col-sm-4">
            <img src="assets/images/udmlogo.jpg" style="float:right;height: 100px;">
        </div>
    </div>
    <div class="row" style="margin-top:20px; text-align: center;">
        <div class="col-sm-12">
            <h4 style="text-align: center;color: #000;font-size: 15px;letter-spacing: 4px;font-weight: bold;">Certificate of Registration for Producers Group</h4>
        </div>
    </div>
    <div class="row" style="text-align: center;">
        <div class="col-sm-12" style="font-size: 13px;">
            <p class="texts">This is to certify that</p>
            <p class="texts Name" style="text-transform: uppercase;"><span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.pgName}}</span></p>
            <p class="texts">at Village: <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.village}}</span>, Gram Panchayat: <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.Panchayat}}</span>, Block; <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.block}}</span></p>
            <p class="texts">has been promoted and registered with DAY-NRLM.</p>
            <p class="texts">ID no:<span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.id}}</span></p>
        </div>
    </div>
    <div class="row" style="margin-bottom:5px;">
        <div class="col-sm-4">
            <p style="font-size:13px;margin-left:25px;">Print Date:<span style="border-bottom: 1px dotted #7b6e6e;">{{today}}</span></p>
        </div>
        <div class="col-sm-3" style="text-align: right;">
            <img src="assets/images/qrcode.png">
        </div>
        <div class="col-sm-5">
           <h5 style="font-weight: bolder;text-align: right;">Signature</h5>
           <p style="text-align:right;font-size:13px;">(Computer generated certificate does not require signature)</p>
        </div>
    </div>
        </div>
    </div>
    
</div>






<div id="print-certificate" style="display: none">
    <div class="container-fluid" style="border: 2px solid #000">
        <div class="row">
            <div class="container-fluid" style="border: 5px solid #000;margin:2px;">
                <div class="row">
            <div class="col-sm-4">
                <img style="height: 100px;" src="assets/images/mrdimage.jpg">
            </div>
            <div class="col-sm-4">
                
            </div>
            <div class="col-sm-4">
                <img src="assets/images/udmlogo.jpg" style="float:right;height: 100px;">
            </div>
        </div>
        <div class="row" style="margin-top:20px; text-align: center;">
            <div class="col-sm-12">
                <h4 style="text-align: center;color: #000;font-size: 15px;letter-spacing: 4px;font-weight: bold;">Certificate of Registration for Producers Group</h4>
            </div>
        </div>
        <div class="row" style="text-align: center;">
            <div class="col-sm-12" style="font-size: 13px;">
                <p class="texts">This is to certify that</p>
                <p class="texts Name"><span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.pgName}}</span></p>
                <p class="texts">at Village: <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.village}}</span>, Gram Panchayat: <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.Panchayat}}</span>, Block; <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.block}}</span></p>
                <p class="texts">has been promoted and registered with DAY-NRLM.</p>
                <p class="texts">ID no:<span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.id}}</span></p>
            </div>
        </div>
        <div class="row" style="margin-bottom:5px;">
            <div class="col-sm-4">
                <p style="font-size:13px;margin-left:25px;">Print Date:<span style="border-bottom: 1px dotted #7b6e6e;">{{today}}</span></p>
            </div>
            <div class="col-sm-3" style="text-align: right;">
                <img src="assets/images/qrcode.png">
            </div>
            <div class="col-sm-5">
               <h5 style="font-weight: bolder;text-align: right;">Signature</h5>
               <p style="text-align:right;font-size:13px;">(Computer generated certificate does not require signature)</p>
            </div>
        </div>
            </div>
        </div>
        
    </div>
<!-- <div class="container-fluid" style="border: 2px solid #000;margin:5px;margin-top:20px; ">
    <div class="row">
        <div class="container-fluid" style="border: 5px solid #000;margin:2px;">
            <div class="row">
        <div class="col-sm-4">
            <img src="assets/images/mrdimage.jpg">
        </div>
        <div class="col-sm-4">
            
        </div>
        <div class="col-sm-4">
            <img src="assets/images/udmlogo.jpg" style="float:right;">
        </div>
    </div>
    <div class="row" style="margin-top:20px; text-align: center;">
        <div class="col-sm-12">
            <h4 style="text-align: center;color: #000;font-size: 19px;letter-spacing: 4px;font-weight: bold;">Certificate of Registration for Producers Group</h4>
        </div>
    </div>
    <div class="row" style="margin-top:20px;text-align: center;">
        <div class="col-sm-12">
            <p class="texts">This is to certify that</p>
            <p class="texts Name"><span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.pgName}}</span> (name of Producers Groups)</p>
            <p class="texts">of Villages: <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.village}}</span>, Gram Panchayat: <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.Panchayat}}</span>, Block; <span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.block}}</span></p>
            <p class="texts">has been promoted and registered with DAY-NRLM.</p>
            <p class="texts">ID no:<span style="border-bottom: 1px dotted #7b6e6e;">{{profileDetails.id}}</span></p>
        </div>
    </div>
    <div class="row" style="margin-top:40px;margin-bottom:20px;">
        <div class="col-sm-4">
            <p style="font-size:17px;margin-left:25px;">Print Date:<span style="border-bottom: 1px dotted #7b6e6e;">{{today}}</span></p>
        </div>
        <div class="col-sm-4" style="text-align: center;">
            <img src="assets/images/qrcode.png">
        </div>
        <div class="col-sm-4">
           <h5 style="font-weight: bolder;text-align: right;margin-right:35px;">Signature</h5>
           <p style="text-align:right;font-size:13px;margin-right:30px;">(Computer generated certificate does not require signature)</p>
        </div>
    </div>
        </div>
    </div>
    
</div> -->
</div>